import {ForgotPasswordConfirmLegacy} from 'domain/usecases';
import {RemoteForgotPasswordConfirmLegacy} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {EntryFlowEndPoints} from '../../endpoints';

export const makeForgotPasswordConfirmLegacy = (): ForgotPasswordConfirmLegacy =>
	new RemoteForgotPasswordConfirmLegacy(
		makeBFFApiUrl(EntryFlowEndPoints.forgotConfirm),
		makeAuthorizeHttpClientDecorator(),
	);
